import BrowserUpdated from '@mui/icons-material/BrowserUpdated';
import { Box, IconButton, Tooltip, Typography } from '@mui/material';
import { action, computed, makeObservable, observable, runInAction } from 'mobx';
import { inject, observer } from 'mobx-react';
import ErrorUtil from '@/util/ErrorUtil';
import ReactComponent from '../ReactComponent';

class RecarregarCacheServidorDeUmProcesso extends ReactComponent {
    processando = false;

    constructor(props) {
        super(props);

        makeObservable(this, {
            processando: observable,
            registro: computed,
            cursor: computed,
            recarregarSemCache: action,
            handleClickRenovarCacheProcesso: action
        });
    }

    get registro() {
        return this.observableProps.registro;
    }

    get cursor() {
        return this.processando ? 'wait' : 'pointer';
    }

    recarregarSemCache = async () => {
        if (this.processando) {
            return;
        }

        runInAction(() => {
            this.processando = true;
        });

        try {
            await this.sessaoStore.recarregarProcesso(this.registro, true);
            this.mensagemStore.abrirMensagemSucesso('Cache renovado e dados recarregados.');
        } catch (error) {
            this.mensagemStore.abrirMensagemErro(
                `Falha ao tentar renovar o cache do processo: ${ErrorUtil.montarMensagemErro(error)}`
            );
            console.error(error);
        } finally {
            runInAction(() => {
                this.processando = false;
            });
        }
    };

    handleClickRenovarCacheProcesso = async () => {
        await this.recarregarSemCache();
    };

    get titulo() {
        return 'Forçar recarregamento de dados do processo';
    }

    render() {
        if (!this.isComponenteHabilitado('CacheServidor')) {
            return null;
        }

        return (
            <Box sx={{ cursor: this.cursor }}>
                <Tooltip title={<Typography>{this.titulo}</Typography>}>
                    <span>
                        <IconButton
                            onClick={this.handleClickRenovarCacheProcesso}
                            disabled={this.processando}
                        >
                            <BrowserUpdated sx={{ color: 'black' }} />
                        </IconButton>
                    </span>
                </Tooltip>
            </Box>
        );
    }
}

export default inject('stores')(observer(RecarregarCacheServidorDeUmProcesso));
